import { map, Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SettingsService } from '../services/settings.service';
import { ServerResponse } from '../response';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceDomainService {
  constructor(
    private settingService: SettingsService,
    private http: HttpClient
  ) {}

  // Получает текст страницы (для оргов/перс данных/...)
  getPage(page: string = ''): Observable<string> {
    return this.http
      .get<ServerResponse<string>>(
        `${this.settingService.settings.urlGTM}/api/service/page?page=${page}&lang=${this.settingService.selectedLang}`
      )
      .pipe(
        map((response) => response.data)
      );
  }

  // Сохраняет текст страницы (для оргов/перс данных/...)
  savePage(text: string, page: string = ''): Observable<void> {
    return this.http
      .post<void>(
        `${this.settingService.settings.urlGTM}/api/service/page`,
        {
          text,
          page,
          lang: this.settingService.selectedLang,
        }
      )
      .pipe(
        map(() => undefined)
      );
  }

  // Отправка SMS участникам
  sendSms(phones: string[], textSms: string, rUid: string, isPaid: boolean): Observable<void> {
    return this.http
      .post(`${this.settingService.settings.urlGTM}/api/service/sms`, {
        textSms,
        rUid: rUid || '',
        isPaid: isPaid || false,
        phones,
      })
      .pipe(
        map(() => undefined)
      );
  }

  // Логирование ошибок и других сообщений в мессенджер
  sendLog(action: string, data: string): Observable<void> {
    // Не отправляем логи в режиме разработки
    if (!environment.production) {
      console.log('[sendLog]', action, data);
      return of(undefined);
    }
    return this.http
      .post<ServerResponse<any>>(`${this.settingService.settings.urlGTM}/api/service/log/`, {
        action,
        data,
      })
      .pipe(
        map(() => undefined)
      );
  }
}
